import { render, staticRenderFns } from "./RadioMiniNormal.vue?vue&type=template&id=31b5f9e0&scoped=true"
import script from "./RadioMiniNormal.vue?vue&type=script&lang=js"
export * from "./RadioMiniNormal.vue?vue&type=script&lang=js"
import style0 from "./RadioMiniNormal.vue?vue&type=style&index=0&id=31b5f9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5f9e0",
  null
  
)

export default component.exports